<template>
  <div class="UserSection">
    <div class="UserSection-Outer">
      <div class="UserSection-User">
        {{ user.name }}
      </div>
      <img
        class="UserSection-Avatar"
        :src="loadAvatar(user.photo)"
        alt="avatar"
      />
    </div>
    <div class="UserSection-Inner">
      <router-link to="/profile" class="Link UserSection-Item">
        Профиль
      </router-link>
      <router-link to="/add" class="Link UserSection-Item"
                   v-if="user.moderation || settings.MULTIUSER_MODE" >
        Новая публикация
      </router-link>
      <router-link to="/my/inactive" class="Link UserSection-Item">
        Мои публикации
      </router-link>
      <router-link to="/stat" class="Link UserSection-Item">
        Статистика
      </router-link>
      <router-link
        v-if="user.moderation"
        to="/moderation/new"
        class="Link UserSection-Item UserSection-Moderation"
      >
        <div>
          Модерация
        </div>
        <div class="UserSection-ModerationNum">
          {{ user.moderationCount }}
        </div>
      </router-link>
      <router-link to="/settings" class="Link UserSection-Item"
                   v-if="user.moderation" >
        Настройки
      </router-link>
      <div class="UserSection-Item UserSection-Logout" @click="logout">
        Выйти
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { loadAvatar } from "@/utils";

export default {
  computed: {
    ...mapGetters(["user", "settings"])
  },

  methods: {
    ...mapActions(["logout"]),
    loadAvatar
  }
};
</script>

<style lang="scss">
.UserSection {
  position: relative;
  z-index: 10;

  &-Outer {
    display: flex;
    align-items: center;
  }

  &-User {
    margin-right: 15px;
    font-size: 1.4rem;
    line-height: 1.4;
    color: var(--color-lightest);
    cursor: default;

    @media (max-width: $screen-mobile) {
      display: none;
    }
  }

  &-Avatar {
    display: block;
    width: 23px;
    height: 23px;
    border-radius: 50%;
  }

  &-Inner {
    position: absolute;
    right: 0;
    display: none;
    width: 155px;
    padding: 33px 0 33px 13px;
    background-color: var(--color-layout-dark);
    border-radius: 10px;
  }

  &:hover .UserSection-Inner {
    display: block;
  }

  &-Item {
    display: block;
    margin-bottom: 12px;
    padding-right: 16px;
    font-size: 1.4rem;
    line-height: 1.4rem;
    white-space: nowrap;

    &:last-child {
      margin-bottom: 0;
    }

    &:hover {
      padding-right: 13px;
      font-size: 1.5rem;
      font-weight: 500;
    }
  }

  &-Moderation {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:hover {
      padding-right: 16px;
    }
  }

  &-ModerationNum {
    width: 19px;
    height: 19px;
    font-size: 1rem;
    line-height: 19px;
    text-align: center;
    color: var(--color-lightest);
    background-color: var(--color-secondary);
    border-radius: 50%;
  }

  &-Logout {
    color: var(--color-secondary);
    cursor: pointer;
  }
}
</style>
